//
// PLEASE PAY ATTENTION TO https://www.w3.org/WAI/WCAG21/Techniques/general/G65
//
import { sanitizeTitle } from "../../utils/customSanitize";
import styles from "./Breadcrumbs.module.scss";
import { ParentsType } from "../../wp/getParentPages";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { CustomLink } from "../CustomLink";
import { SmallCarousel } from "./SmallCarousel/SmallCarousel";
import { CustomSVG } from "../_primitives/CustomSVG/CustomSVG";

export interface BreadcrumbProps {
  // post: Post;
  breadcrumbPositon:
    | "is-justify-content-flex-start"
    | "is-justify-content-center"
    | "is-justify-content-flex-end";
  showOnMobile?: boolean;
  parents: ParentsType;
  extraClass?: string;
  breadcrumbTitle?: string;
}

export const Breadcrumbs = ({
  // post,
  breadcrumbPositon = "is-justify-content-flex-start",
  parents,
  showOnMobile = true,
  extraClass = "",
  breadcrumbTitle,
}: BreadcrumbProps) => {
  // const title = breadcrumbTitle ? breadcrumbTitle : getTitle({ post });
  // const replacedTitle = title
  //   .replace(/<strong>/g, "")
  //   .replace(/<\/strong>/g, "")
  //   .replace(/<br>/g, " ")
  //   .replace(/<\/br>/g, " ");

  const { getLabel, getIcon } = useGlobalContext();
  /**
   * Render all breadcrumb <li> items. Reused by mobile carousel and desktop list.
   * - Adds "embla-slide" to <li> when used inside the carousel.
   * - Keeps original behaviors (span when no URL, sanitizeTitle, etc.).
   */
  const renderItems = (isCarousel: boolean) => {
    const liClass = isCarousel ? "embla-slide" : undefined;

    // Root / Home
    const items: React.ReactNode[] = [
      <li className={liClass} key="root">
        <CustomLink href={"/"} target={"_self"} className={styles.item}>
          {!isCarousel ? (
            getLabel("breadcrumb_root")
          ) : (
            <CustomSVG
              src={getIcon("house")}
              className="is-flex"
              wrapper="span"
              width={16}
              height={16}
              aria-hidden="true"
            />
          )}
        </CustomLink>
      </li>,
    ];
    const unemptyParentPage = parents.filter((p) => !p.isEmptyParentPage);
    // Parents & Current page
    unemptyParentPage.forEach((el, i) => {
      const isLast = i === unemptyParentPage.length - 1;
      const title = isLast && breadcrumbTitle ? breadcrumbTitle : el.title;

      const cleanTitle = title
        ?.replace?.(/<strong>/g, "")
        .replace(/<\/strong>/g, "")
        .replace(/<br>/g, " ")
        .replace(/<\/br>/g, " ");

      const key = el.url ?? i;
      items.push(
        <li
          className={liClass}
          {...(i === unemptyParentPage.length - 1
            ? { ["aria-current"]: "page" }
            : {})}
          key={key}
        >
          {el.url && !isLast ? (
            <CustomLink href={el.url} target="_self" className={styles.item}>
              {cleanTitle}
            </CustomLink>
          ) : (
            <span
              className={styles.item}
              dangerouslySetInnerHTML={{
                __html: sanitizeTitle(cleanTitle),
              }}
            />
          )}
        </li>,
      );
      // if (el.url) {
      //   items.push(
      //     <li className={liClass} key={key}>
      //       <CustomLink href={el.url} target="_self" className={styles.item}>
      //         {removeStrongTitle}
      //       </CustomLink>
      //     </li>,
      //   );
      // } else {
      //   items.push(
      //     <li className={liClass} key={key}>
      //       <span
      //         className={styles.item}
      //         dangerouslySetInnerHTML={{
      //           __html: sanitizeTitle(removeStrongTitle),
      //         }}
      //       />
      //     </li>,
      //   );
      // }
    });

    // Current page (aria-current)
    // items.push(
    //   <li className={liClass} aria-current="page" key="current">
    //     <span
    //       className={styles.item}
    //       dangerouslySetInnerHTML={{
    //         __html: sanitizeTitle(replacedTitle ?? ""),
    //       }}
    //     />
    //   </li>,
    // );

    return items;
  };
  return (
    <nav
      aria-label="Breadcrumbs"
      className={`${styles.breadcrumbs} ${!showOnMobile ? "is-hidden-mobile" : ""} ${extraClass}`}
    >
      {/* Touch: carousel */}
      <SmallCarousel extraClassName="is-hidden-desktop">
        {renderItems(false)}
      </SmallCarousel>

      {/* Desktop: list */}
      <ul className={`${breadcrumbPositon} is-hidden-touch`}>
        {renderItems(false)}
      </ul>
    </nav>
  );
};
